import clsx from "clsx";
import { format, getDay, isValid } from "date-fns";
import { type FC } from "react";

import "./EventDayDate.scss";
import { useNavigate } from "react-router-dom";

interface EventDayDateProps {
  participants: number;
  date: Date | undefined;
  amount: number;
  isFull?: boolean;
  id?: string;
  isDate?: boolean;
  /** Shown when there is no specific date (e.g. timeDescription) */
  fallbackLabel?: string;
}

export const EventDayDate: FC<EventDayDateProps> = ({
  participants,
  date,
  amount,
  id,
  isFull,
  isDate,
  fallbackLabel,
}) => {
  const navigate = useNavigate();
  const daysOfWeekHebrew = [
    "ראשון",
    "שני",
    "שלישי",
    "רביעי",
    "חמישי",
    "שישי",
    "שבת",
  ];
  const type =
    (participants >= amount || isFull)
      ? "full"
      : amount / 2 <= participants
        ? "not-full"
        : "";

  const getDayInHebrew = (date: Date): string => {
    const dayIndex = getDay(date);
    return daysOfWeekHebrew[dayIndex];
  };

  return (
    <div className={clsx("event-day-date", type, id && "pointer")} onClick={() => {
      if (id) navigate(`/events/${id}`);
    }}>
      <p className="day">{date ? getDayInHebrew(date) : ""}</p>
      <p className="number">
        {date && isValid(date)
          ? format(date, isDate ? "dd/MM" : "dd")
          : (fallbackLabel ?? "ללא זמן")}
      </p>
    </div>
  );
};
